import React, { memo, useCallback } from "react";
import Popupz from "../../atoms/Popupz";
import Buttonz from "../../atoms/Buttonz";
import { useDispatch } from "react-redux";
import { hidePopup, showPopup } from "../../../redux/actions";

const SignupExpiredPopup = () => {
  const dispatch = useDispatch();

  const handleClose = useCallback(() => {
    dispatch(hidePopup());
  }, [dispatch]);

  const handleRequestNewLink = useCallback(() => {
    dispatch(hidePopup());
    dispatch(showPopup("signup"));
  }, [dispatch]);

  return (
    <Popupz
      title="Signup link expired"
      text={
        <>
          Your signup link has expired or was cancelled.
          <br />
          Please request a new link to continue.
        </>
      }
      onClose={handleClose}
      popupId="signup-expired"
      // iconIllus="chara00"
    >
      <div className="form-box">
      <Buttonz label="Request a new link" onClick={handleRequestNewLink} />
      <Buttonz
        label="Close"
        className="secondary lined"
        onClick={handleClose}
      />
      </div>
    </Popupz>
  );
};

export default memo(SignupExpiredPopup);
